import './index.scss';

function About() {

  return (
    <div className='section about space' id='about'>
      <p className='title'>About Eizy</p>
      <p className='desc'>Nice to meet you  ๐•ᴗ•๐</p>
       <div className='intro'>
        <p> A Frontend Developer with 3 years of full-time experience and full-stack capability.</p>
        <p>
          I am <span className='highlight'>looking for an internship or a full-time position</span> .
        </p>
        <p className='highlight break'>Open to all opportunity  ;)</p>
        <p className='break'>Besides writing code, I'm also interested in UI&UX.</p>
        <p>When I am not coding, I am enjoying some great design, vivid motion, and some 3D effects.</p>
        <p>And try to implement them into my product.</p>
      </div>
    </div>
  );
}
export default About;
